function TivoliArrow(parent) {
  this.parent = parent;
  this.running = false;

  this.start = function() {
    this.canvas = document.createElement("canvas");
    this.parent.appendChild(this.canvas);
    this.running = true;
    this.redraw();
  }.bind(this);

  this.stop = function() {
    this.canvas = null;
    this.parent = null;
    this.running = false;
  }.bind(this);

  this.redraw = function() {
    if (!this.running) {
      return;
    }

    var canvas = this.canvas;
    var ctx = canvas.getContext('2d');

    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = ctx.webkitBackingStorePixelRatio ||
                            ctx.mozBackingStorePixelRatio ||
                            ctx.msBackingStorePixelRatio ||
                            ctx.oBackingStorePixelRatio ||
                            ctx.backingStorePixelRatio || 1;
    var canvasScalingRatio = Math.max(devicePixelRatio / backingStoreRatio, 1);

    var w = this.canvas.parentElement.clientWidth;
    var h = this.canvas.parentElement.clientHeight; 

    canvas.width = w * canvasScalingRatio;
    canvas.height = h * canvasScalingRatio;

    canvas.style.width = w + "px";
    canvas.style.height = h + "px";

    var basew = 58;
    var scale = w / 58;
    var scaledh = h * (58 / w)

    var arrowHead = new Path2D('M27,11.1c1.7-1.9,3.4-3.7,4.6-4.9c1.2-1.2,1.9-1.7,2.7-2.3C35,3.5,35.7,3,36.5,2.5c0.8-0.4,1.7-0.8,2.6-1.1c0.9-0.3,2-0.6,2.8-0.8C43.5,0.2,44.5,0,45.8,0c1.3,0.1,2.7,0.5,4,0.8c0.9,0.8,1.6,2,1.8,3.1c0.2,1.1,0,2.2-0.4,3c-0.4,0.9-0.9,1.6-1.6,2.1c-4.6,1.4-9.1,3.1-12.1,4.5c-3,1.4-4.4,2.5-5.3,3.4c-0.9,0.9-1.4,1.5-1.8,2.2c-0.4,0.7-0.8,1.4-1.1,2.4c-0.3,1-0.6,2.4-0.7,3.8c-0.1,1.4,0,2.9-0.1,4.3c-0.1,1.4-0.3,2.8-0.5,3.6c-0.2,0.8-0.4,1.1-0.6,1.3c-0.4,0.4-0.9,0.7-1.4,0.6c-0.4-0.3-0.8-0.6-1.1-1.1c-0.3-0.4-0.5-0.9-0.6-2.1c-0.2-1.2-0.3-3.1-0.5-4.9c-0.2-1.8-0.5-3.6-0.8-4.8c-0.3-1.2-0.7-1.9-1.1-2.5c-0.4-0.6-0.9-1.2-1.5-1.8c-0.6-0.6-1.3-1.2-2.1-1.8c-0.8-0.6-1.6-1.1-2.9-1.7c-1.3-0.6-3-1.2-4.8-1.8c-1.8-0.6-3.6-1.1-4.9-1.5c-1.3-0.4-2-0.6-2.6-0.9C2.6,9.7,2,9.4,1.6,9.1c-0.8-0.8-1-1.4-1.4-2.1C0.1,6.5,0,6,0,5.4c0-0.6,0.2-1.1,0.4-1.6C0.8,3,1,2.5,1.8,1.8c0.4-0.3,0.9-0.5,1.5-0.6C4.5,0.8,6,0.7,7.5,0.8c1.5,0.2,3.1,0.5,4.8,0.9c1.6,0.4,3.3,1.4,5.2,2.6c1,0.6,1.9,1.3,2.8,2.4c1,1.2,2,2.8,2.8,4.6');
    var arrowEnd1 = new Path2D('M22,38.3c-0.1,0-0.3,0-0.7,0.2');
    var arrowEnd2 = new Path2D('M20.8,38.6c-0.1,0-0.1,0-0.4,0.1c-0.5,0.1-1-0.1-1.4-0.4c0,0,0,0,0,0c0,0,0-0.1-0.1-0.1c-0.4-0.7-0.6-1.4-0.9-2c-0.6-1.2-1.1-2.1-2.2-3.2c-0.5-0.5-1.2-1-2-1.5c-0.7-0.5-1.5-1-2.5-1.5c-1.1-0.5-2.4-1-4.1-1.3c-1.7-0.4-3.6-0.7-4.9-1.1c-1.2-0.5-1.7-1.1-2-1.6C-0.1,25.1,0,24.8,0,24.2c0.1-0.5,0.3-1,1-1.4c0.3-0.2,0.8-0.5,1.4-0.6C3,22,3.6,21.8,4.5,21.9c0.9,0,2,0.3,3.2,0.7c1.2,0.4,2.4,1.1,3.8,2.1c1.4,0.9,2.9,2.1,4.2,3.5c1.3,1.4,2.5,2.9,3.5,4.5v-8.2c-1-1.2-2.2-2.2-3.6-3.1c-1.4-0.9-3.2-1.7-5.1-2.4c-1.9-0.7-4.1-1.3-5.6-1.6c-1.5-0.4-2.3-0.6-2.9-0.9c-1.2-0.7-1.9-2-1.7-3c0.1-0.5,0.3-0.9,0.5-1.2C0.8,12.1,0.9,12,1,11.9c0.1-0.1,0.2-0.2,0.4-0.2c0.5-0.2,1-0.3,1-0.3c0.9-0.1,1.8,0.1,1.8,0.1c1.9,0.4,2.8,0.5,3.5,0.8c1.2,0.4,2.1,0.8,2.8,1.2c0.8,0.4,1.6,0.9,2.4,1.4c2.3,1.5,4,3.3,6,5.5v-4.6c-0.4-0.7-0.8-1.5-1.3-2.1c-0.5-0.7-1-1.3-1.5-1.8c-0.5-0.5-1.1-1-1.7-1.4C13.9,9.9,13.2,9.4,12,9c-1.2-0.5-2.9-1.1-4.6-1.5C5.7,7,4,6.6,3,6.3c-1-0.3-1.3-0.7-1.5-1C1.2,5,0.9,4.6,0.8,4.3C0.7,4,0.8,3.8,0.8,3.5c0-0.3,0-0.5,0.1-0.8C1,2.3,1.3,1.9,1.7,1.6c1.2-1,3.3-0.9,5.1-0.3c0.5,0.2,1,0.3,1.9,0.8c0.8,0.4,2,1.1,3.2,1.9c1.1,0.8,2.3,1.5,3.1,2.3c0.9,0.7,1.5,1.4,2,2c0.5,0.6,0.9,1.2,1.2,1.6c0.3,0.4,0.4,0.6,0.5,0.8c0-1.5,0-3,0-4.6c0-1.5-0.1-3.1,0-4.1c0.1-1,0.3-1.3,0.5-1.6c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.9,0.2,1.1,0.5c0.3,0.4,0.4,0.9,0.4,1.5c0,0.6,0,1.3,0,2.7c0,1.4,0,3.6,0,5.8c0.8-1.5,1.9-2.8,3.3-4.2c1.5-1.4,3.4-2.8,5-3.8c1.6-1,2.9-1.5,3.8-1.8c0.9-0.3,1.3-0.4,1.7-0.5c0.4-0.1,0.9-0.1,1.3,0c0.4,0.1,0.8,0.2,1.2,0.3c0.3,0.2,0.7,0.4,0.9,0.6c0.5,0.5,0.8,1.2,0.8,1.9c0,0.4-0.2,0.7-0.4,1c-0.4,0.7-0.9,1-1.4,1.4c-0.3,0.2-0.6,0.3-1.2,0.5c-0.6,0.2-1.6,0.4-2.6,0.7c-0.9,0.3-1.8,0.6-2.6,0.8c-1.5,0.4-2.2,0.6-3.3,1.2c-1,0.6-2.3,1.3-3.4,2.4c-0.5,0.5-1,1.1-1.5,1.8c-0.5,0.7-0.9,1.4-1.1,2.2c-0.5,1.6-0.5,3.5-0.4,5.2c1.2-1.6,2.6-3.1,4.1-4.3c1.5-1.2,3-2.3,4.1-2.9c1.1-0.7,1.8-0.9,2.5-1.2c1.3-0.6,2.6-1,3.8-1.1c0.6-0.1,1.2-0.2,1.6-0.2c0.8,0,1.2,0.2,1.7,0.5c0.2,0.1,0.4,0.4,0.7,0.6c0.2,0.3,0.5,0.5,0.6,1.1c0.1,0.5,0,1.3-0.4,1.8c-0.4,0.5-1.1,0.9-1.5,1.1c-0.5,0.3-0.8,0.4-1.6,0.7c-0.8,0.2-2.1,0.5-3.3,0.9c-1.2,0.4-2.5,0.8-3.8,1.4c-1.4,0.6-2.9,1.3-4.2,2.2c-1.3,0.9-2.4,1.9-3.1,2.5c-0.6,0.6-0.8,0.8-0.9,1.1v8c1.3-2,2.7-3.8,4.2-5.3c1.5-1.5,3.1-2.7,4.2-3.5c1.1-0.8,1.7-1.1,2.3-1.4c1.2-0.6,2.4-1,3.5-1c0.5,0,1.1-0.1,1.8,0c0.7,0.1,1.4,0.3,2,0.7c0.6,0.4,1,0.9,1.1,1.6c0.1,0.6-0.2,1.4-0.5,1.9c-0.3,0.6-0.7,1-1.6,1.3c-0.9,0.3-2.2,0.6-3.5,0.9c-1.3,0.3-2.6,0.6-3.7,1c-1,0.4-1.8,0.8-2.6,1.2c-0.7,0.5-1.4,1-2,1.4c-0.6,0.4-1.1,0.8-1.5,1.2c-0.4,0.4-0.8,0.9-1.2,1.4c-0.4,0.6-0.7,1.2-1,2c-0.3,0.7-0.5,1.5-0.6,2.3');

    var xofs = 0;
    var yofs = 0;

    ctx.scale(canvasScalingRatio, canvasScalingRatio);

    ctx.save();
    ctx.scale(scale, scale);
    ctx.translate(xofs + 4, yofs+ scaledh - 35);
    ctx.fill(arrowHead);
    ctx.restore();

    ctx.beginPath();
    var x1 = Math.round(xofs + (29 * scale));
    var y1 = Math.round(yofs + (35 * scale));
    ctx.moveTo(x1, y1);
    var x2 = Math.round(xofs + (29 * scale));
    var y2 = Math.round(yofs + h - (20 * scale));
    ctx.lineTo(x2, y2);

    ctx.lineWidth = Math.round(4 * scale);
    ctx.stroke();

    ctx.save();
    ctx.translate(xofs, yofs);
    ctx.scale(scale, scale);
    ctx.scale(1.4, 1.4);
    ctx.fill(arrowEnd1);
    ctx.fill(arrowEnd2);
    ctx.restore();

    window.requestAnimationFrame(this.redraw.bind(this));
  }.bind(this);
}
